import { IDashboard, IWidget } from '@/pages/Dashboards/dashboards.types.ts'
import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import { IParameter } from '@/pages/Parameters/parameters.types.ts'

const generateWidget = (
  dashboardId: IDashboard['id'],
  type: IWidget['type'],
  settings: IWidget['configuration']['settings']
): Omit<IWidget, 'id' | 'createdAt' | 'updatedAt'> => {
  return {
    type,
    dashboardId,
    configuration: {
      topLeftX: 0.1,
      topLeftY: 0.1,
      width: 0.2,
      height: 0.1,
      settings,
    },
  } as any
}

const getWidgetDataConfig = (
  widget: IWidget
): { devices: Array<IEquipment['id']>; parameters: Array<IParameter['id']> } => {
  switch (widget.type) {
    case 'linear':
      return {
        devices: widget.configuration.settings.lines.map((l) => l.deviceId),
        parameters: widget.configuration.settings.lines.map((l) => l.parameterId),
      }
    case 'svg':
      return {
        devices: [
          ...widget.configuration.settings.color.map((s) => s.device_id),
          ...widget.configuration.settings.rotations.map((s) => s.device_id),
          ...widget.configuration.settings.movements.map((s) => s.device_id),
          ...widget.configuration.settings.visibility.map((s) => s.device_id),
          ...widget.configuration.settings.text.map((s) => s.device_id),
        ],
        parameters: [
          ...widget.configuration.settings.color.map((s) => s.parameter_id as IParameter['id']),
          ...widget.configuration.settings.rotations.map((s) => s.parameter_id as IParameter['id']),
          ...widget.configuration.settings.movements.map((s) => s.parameter_id as IParameter['id']),
          ...widget.configuration.settings.visibility.map((s) => s.parameter_id as IParameter['id']),
          ...widget.configuration.settings.text.map((s) => s.parameter_id as IParameter['id']),
        ],
      }
    case 'text':
      return {
        devices: widget.configuration.settings.parametersText.map((p) => p.deviceId),
        parameters: widget.configuration.settings.parametersText.map((p) => p.parameterId),
      }
    case 'table':
      return {
        devices: widget.configuration.settings.equipment,
        parameters: widget.configuration.settings.dataRows.map((r) => r.parameterId),
      }
  }
}

const dashboardsUtils = { generateWidget, getWidgetDataConfig }
export default dashboardsUtils
